import script from "./DocPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./DocPermission.vue?vue&type=script&setup=true&lang=js"

import "./DocPermission.vue?vue&type=style&index=0&id=3d0bf74c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0bf74c"]])

export default __exports__